<!-- MAIN PAGE WRAPPER -->
<div class="main-content">
  <div class="login-card">
    <div id="login-recaptcha-container"></div>

    <!-- HEADER -->
    <div class="header-row">
      <!-- Back button always visible -->
      <button
        mat-icon-button
        (click)="handleBack()"
        style="position: absolute; left: 12px"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>

      <!-- Centered Title -->
      <h3
        class="dialog-title"
        style="margin: 0; font-size: 14px; font-weight: 600"
      >
        {{ otpSent ? "Confirm" : "Login" }}
      </h3>
    </div>

    <div class="login-content">
      <!-- Title Message -->
      <h2 class="welcome-title">
        {{ otpSent ? "Confirm your number" : "Welcome back!" }}
      </h2>

      <!-- ========================= -->
      <!-- OTP VERIFICATION VIEW -->
      <!-- ========================= -->
      <div *ngIf="otpSent" class="otp-container" style="padding: 0">
        <p class="otp-text">
          Enter the code we sent to {{ user.countryCode }} {{ user.mobile }}
        </p>

        <div class="otp-inputs">
          <input
            *ngFor="let digit of otpDigits; let i = index; trackBy: trackByIdx"
            type="tel"
            [id]="'otp-' + i"
            maxlength="6"
            class="otp-box"
            [value]="otpDigits[i]"
            (input)="moveFocus($event, i)"
            (keydown)="handleBackspace($event, i)"
          />
        </div>

        <a class="resend-link" (click)="otpSent = false"
          >Choose another option to get the code</a
        >

        <button type="button" class="primary-cta" (click)="verifyOtp()">
          Verify OTP
        </button>
      </div>

      <!-- ========================= -->
      <!-- INITIAL LOGIN VIEW (Phone/Email) -->
      <!-- ========================= -->
      <div *ngIf="!otpSent">
        <!-- MOBILE LOGIN FORM -->
        <form *ngIf="activeTab === 'mobile'" #mobileForm="ngForm" class="form">
          <div class="phone-row mb-12">
            <!-- Country Code -->
            <div class="country-select">
              <label class="input-label">&nbsp;</label>
              <div class="custom-input-box">
                <mat-select
                  [(ngModel)]="user.countryCode"
                  name="countryCode"
                  panelClass="wide-country-dropdown"
                  disableOptionCentering
                >
                  <mat-select-trigger>
                    <div
                      class="flex-center"
                      *ngIf="getSelectedCountry() as selected"
                    >
                      <img [src]="selected.flag" class="flag-icon-small" />
                      {{ selected.code }}
                    </div>
                  </mat-select-trigger>
                  <mat-option *ngFor="let c of countryList" [value]="c.code">
                    <img [src]="c.flag" class="flag-icon" />
                    {{ c.name }} ({{ c.code }})
                  </mat-option>
                </mat-select>
              </div>
            </div>

            <!-- Phone Number -->
            <div class="phone-input flex-1">
              <label class="input-label"
                >Phone number <span class="required-star">*</span></label
              >
              <div
                class="custom-input-box"
                [class.error]="submitted && !user.mobile"
              >
                <mat-icon class="prefix-icon">phone</mat-icon>
                <input
                  type="text"
                  [(ngModel)]="user.mobile"
                  name="mobile"
                  placeholder="Ex: 501234567"
                />
              </div>
              <div class="error-msg" *ngIf="submitted && !user.mobile">
                Phone is required
              </div>
            </div>
          </div>

          <button type="button" class="primary-cta" (click)="sendOtp()">
            Get OTP
          </button>
        </form>

        <!-- EMAIL LOGIN FORM -->
        <form
          *ngIf="activeTab === 'email'"
          #emailForm="ngForm"
          (ngSubmit)="loginHandler(emailForm, $event)"
          class="form"
        >
          <div class="full-width mb-12">
            <label class="input-label"
              >Email ID <span class="required-star">*</span></label
            >
            <div
              class="custom-input-box"
              [class.error]="submitted && !user.email"
            >
              <mat-icon class="prefix-icon">mail_outline</mat-icon>
              <input
                type="email"
                placeholder="Ex: user@example.com"
                [(ngModel)]="user.email"
                name="email"
                required
              />
            </div>
            <div class="error-msg" *ngIf="submitted && !user.email">
              Email is required
            </div>
          </div>

          <div class="full-width mb-12">
            <label class="input-label"
              >Password <span class="required-star">*</span></label
            >
            <div
              class="custom-input-box"
              [class.error]="submitted && !user.password"
            >
              <mat-icon class="prefix-icon">lock_outline</mat-icon>
              <input
                [type]="hidePassword ? 'password' : 'text'"
                placeholder="Enter password"
                [(ngModel)]="user.password"
                name="password"
                required
              />
              <mat-icon
                class="eye-icon"
                (click)="hidePassword = !hidePassword"
                >{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon
              >
            </div>
            <div class="error-msg" *ngIf="submitted && !user.password">
              Password is required
            </div>
          </div>

          <div class="forgot-password-row">
            <a class="forgot-password-link" (click)="openForgotPasswordDialog()">Forgot Password?</a>
          </div>

          <button type="submit" class="primary-cta" [disabled]="isSubmitting">
            Log in
          </button>
        </form>

        <!-- DIVIDER -->
        <div class="divider"><span>or</span></div>

        <!-- SOCIAL BUTTONS (Stacked) -->
        <div class="socials">
          <button type="button" class="social-button" (click)="googleLogin()">
            <img
              class="social-icon"
              src="assets/icons/google.png"
              alt="Google"
            />
            <span>Continue with Google</span>
          </button>

          <!-- Toggle Button -->
          <button
            type="button"
            class="social-button"
            (click)="switchTab(activeTab === 'mobile' ? 'email' : 'mobile')"
          >
            <mat-icon class="social-icon-mat">{{
              activeTab === "mobile" ? "mail" : "phone_iphone"
            }}</mat-icon>
            <span>{{
              activeTab === "mobile"
                ? "Continue with Email"
                : "Continue with Mobile Number"
            }}</span>
          </button>
        </div>

        <!-- FOOTER -->
        <div class="footer-area">
          <div class="register-section">
            <span class="register-text">Don't have an account?</span>
            <a class="register-link" (click)="openCreatemyaccountbox()"
              >Register</a
            >
          </div>

          <div class="recaptcha-disclaimer">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy" target="_blank"
              >Privacy Policy</a
            >
            and
            <a href="https://policies.google.com/terms" target="_blank"
              >Terms of Service</a
            >
            apply.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
